module.exports = __webpack_public_path__ + "img/加入我们-图.1b4c9231.png";